import { useMutation } from '@tanstack/react-query'
import LoginServicer from '../../../service/LoginService'
import {
  showErrorToast,
  showSuccessToast,
  showCredentialToast,
  showLoadingToast,
} from '../../../utils/showToast'
import { LOGIN_UNAUTHORIZED } from '../../../data/system_settings'

import { useDispatch } from 'react-redux'
import {
  auth_finish_action,
  auth_login_success_action,
  auth_login_unauthorized_action,
  auth_start_login_request_action,
} from '../../../context/actions/auth_action'

import { accountService } from '../../../service/AccountService'

export function AccountDTO(payload) {
  if (!payload || typeof payload !== 'object') {
    throw new Error('Invalid payload: Payload must be a non-null object.')
  }
  const accountData = payload.account || {}

  return {
    account: {
      uuid: accountData.uuid || 'N/A',
      name: accountData.name || 'N/A', // payload mới: fullName
      schoolId: accountData.schoolId || 'N/A', // payload mới: schoolId
      personalEmail: accountData.personalEmail || 'N/A',
      schoolEmail: accountData.schoolEmail || 'N/A',
      phoneNumber: accountData.phoneNumber || 'N/A',
      course: accountData.course || 'N/A', // payload mới: studentCourse
      major: accountData.major || 'N/A', // payload mới: major
      faculty: accountData.faculty || 'N/A',
      school: accountData.school || 'N/A',
      status: accountData.status || 'UNKNOWN',
      totalPayment:
        accountData.totalPayment !== undefined ? accountData.totalPayment : 0,
      groups: Array.isArray(accountData.groups)
        ? accountData.groups.map((group) => ({
            uuid: group.uuid || 'N/A',
            name: group.name || 'N/A',
            description: group.description || 'N/A',
            createdAt: group.createdAt || 0,
            createdBy: group.createdBy || 'N/A',
          }))
        : [],
      // Các trường sau không có trong payload mới, nên được comment lại:
      // devices: Array.isArray(accountData.devices) ? accountData.devices : [],
      // books: Array.isArray(accountData.books) ? accountData.books : [],
      // className: accountData.className || 'N/A',
      createdAt: accountData.createdAt || 0,
      createdBy: accountData.createdBy || 'N/A',
      updatedAt: accountData.updatedAt || 0,
      updatedBy: accountData.updatedBy || 'N/A',
    },
    uuid: payload.uuid || 'N/A', // Giữ lại nếu vẫn cần
    accessToken: payload.accessToken || 'N/A', // Giữ lại nếu vẫn cần
    publicKey: payload.publicKey || 'N/A', // Giữ lại nếu vẫn cần
    email: payload.email || 'N/A', // Giữ lại nếu vẫn cần
  }
}

export default function useLoginMutation() {
  const dispatch = useDispatch()

  const loginMutation = useMutation({
    mutationFn: async ({ email, password }) => {
      const { success, message } = await LoginServicer.login({
        email,
        password,
      })

      if (!success) throw new Error(message)

      const { accessToken, publicKey, email: resEmail, uuid } = message.content
      const { success: accountSuccess, message: accountMessage } =
        await accountService.getMe(accessToken)

      if (!accountSuccess) {
        throw new Error(message.content)
      }

      return AccountDTO({
        account: accountMessage.content,
        accessToken,
        message: resEmail,
        publicKey: publicKey,
      })
    },
    onMutate: () => {
      showLoadingToast('Đang đăng nhập...')
      dispatch(auth_start_login_request_action())
    },
    onError: (error) => {
      if (error.message.content === LOGIN_UNAUTHORIZED) {
        showCredentialToast('Bạn không có quyền truy cập')
        dispatch(auth_login_unauthorized_action())
      } else {
        showErrorToast({
          message: 'Đăng nhập thất bại',
          error: error.message.content || 'không xác định',
        })
      }
    },
    onSuccess: async (data) => {
      dispatch(auth_login_success_action(data))

      showSuccessToast('Đăng nhập thành công')
    },
    onSettled: () => {
      dispatch(auth_finish_action())
    },
  })

  return { loginMutation }
}
